@if(value) {
    <span class="text-sm font-normal text-widget sm:text-xs" [class.truncate]="!enableListMultiline"
          [style.overflow-wrap]="enableListMultiline ? 'anywhere' : null"
          [style.text-wrap]="enableListMultiline ? 'pretty' : null">
        {{ value | bytes }}
    </span>
}
